import gql from 'graphql-tag';

const GET_CATEGORIZED_WORDS = gql`
  query CategorizedWords($lesson_id: Int) {
    categorized_words(lesson_id: $lesson_id) {
      nbHits
      hits {
        id
        word
        translation
        definition {
          word
          pronunciation
          inflection
          meaning
          example
        }
        notes
        is_memorized
        is_important
        program_id
        lesson_id
      }
    }
  }
`;

const GET_VOCABULARY_LIST = gql`
  query GetVocabularyList($lesson_id: Int!) {
    getVocabularyList(lesson_id: $lesson_id) {
      nbHits
      hits {
        id
        word
        translation
        definition {
          word
          pronunciation
          inflection
          meaning
          example
        }
        notes
        is_memorized
        is_important
        program_id
        lesson_id
      }
    }
  }
`;

const STORE_VOCABULARY = gql`
  mutation storeVocabulary($lesson_id: Int!, $program_id: Int!, $word: String!) {
    store_vocabulary(lesson_id: $lesson_id, program_id: $program_id, word: $word) {
      result
      status
    }
  }
`;

const STORE_VOCABULARY_MSB = gql`
  mutation storeVocabulary($lesson_id: Int!, $program_id: Int!, $word: String!) {
    storeVocabulary(
      lesson_id: $lesson_id,
      program_id: $program_id,
      word: $word
    ) {
      result
      status
    }
  }
`;

export { GET_CATEGORIZED_WORDS, GET_VOCABULARY_LIST, STORE_VOCABULARY, STORE_VOCABULARY_MSB };
